import FilterRow from "../../../component/filter-row/FilterRow";
import ReportTable from "../../../component/report-table/ReportTable";
import TabsContainer from "../../../component/tabs-container/TabsContainer";
import { CustomerDataEntry } from "../../../service/utils/interfaces";
import "./ReportingPage.scss";

interface ReportingPageUIProps {
  customerList: CustomerDataEntry[];
  currentTab: number;
  isUserTipping: boolean;
  yearlyReport: string[][];
  monthlyReport: string[][];

  setSelectedCustomer: (customer: CustomerDataEntry) => void;
  setCurrentTab: (tabIdx: number) => void;
  manageFile: (link: string, download: boolean) => void;

  darkMode: boolean;
  width: number;
}

const ReportingPageUI = (props: ReportingPageUIProps) => {
  const renderTabContent = () => {
    const contentArray = [];
    contentArray.push(
      <ReportTable
        id="yearly-report-list"
        data={props.yearlyReport}
        onOpenLink={(link, dl) => props.manageFile(link, dl)}
        darkMode={props.darkMode}
      />
    );
    contentArray.push(
      <ReportTable
        id="monthly-report-list"
        data={props.monthlyReport}
        onOpenLink={(link, dl) => props.manageFile(link, dl)}
        darkMode={props.darkMode}
      />
    );
    return contentArray;
  };

  return (
    <div className={"reporting-wrapper" + (props.darkMode ? " dark" : "")}>
      <div className="filter-row row">
        <FilterRow
          width={props.width}
          customerData={props.customerList}
          onChangeCustomerData={(val) => props.setSelectedCustomer(val)}
          isTippingUser={props.isUserTipping}
          darkMode={props.darkMode}
        />
      </div>
      <TabsContainer
        darkTheme={props.darkMode}
        isUserTipping={props.isUserTipping}
        tabList={["Year to Date", "Monthly"]}
        contentList={renderTabContent()}
        currentTab={props.currentTab}
        onSwitchTab={(tabIdx) => props.setCurrentTab(tabIdx)}
      />
    </div>
  );
};

export default ReportingPageUI;
